import { MapPin, ThumbsUp, Star, type LucideIcon } from 'lucide-react';

interface ReviewTypeConfig {
  icon: LucideIcon;
  color: string;
  bg: string;
  label: string;
}

export function getReviewTypeConfig(reviewType?: string): ReviewTypeConfig {
  switch (reviewType) {
    case 'google_review':
      return { icon: MapPin, color: '#05C274', bg: '#E6F9F0', label: 'Google Review' };
    case 'facebook_like':
      return { icon: ThumbsUp, color: '#4750DD', bg: '#E8F4FD', label: 'Facebook' };
    default:
      return { icon: Star, color: '#E89B0C', bg: '#FEF6E0', label: 'Review' };
  }
}
